import {useQuery} from '../../../hooks/QueryHooks';
import {TermConditionObject} from './FooterType';

const useTerm = () => {
	const {data} = useQuery<TermConditionObject>(`appendices/enterpriser/terms-or-privacy?type=taq`);

	return {data};
};

export default useTerm;
